import { fetchPostFavoriteList } from '@/api/post/post';
export default {
  data() {
    return {
      id: 0, // post id
      postFavoriteLoaded: false,
      postFavoriteData: [],
      postFavoritePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.postFavoriteLoaded = false;
  },
  methods: {
    initPostFavorite() {
      if (this.postFavoriteLoaded) {
        return;
      }

      this.getPostFavoriteList();
    },
    getPostFavoriteList() {
      let params = {
        current: this.postFavoritePage.currentPage,
        size: this.postFavoritePage.pageSize,
        postId: this.id
      }
      fetchPostFavoriteList(params).then(response => {
        if (response.data.data != null) {
          this.postFavoriteData = response.data.data.records;
          this.postFavoriteData.forEach(favorite => {
            favorite.favoriteByRealname = favorite.favoriteByMemberType === 1
              ? favorite.favoriteByRelatedPersonalRealname
              : favorite.favoriteByRealname;
          });
          this.postFavoritePage.total = response.data.data.total;
        } else  {
          this.postFavoriteData = []
          this.postFavoritePage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取收藏列表失败',
          type: 'error'
        });
      });
      this.postFavoriteLoaded = true;
    },
    postFavoriteCurrentChange(val) {
      this.postFavoritePage.currentPage = val;
      this.getPostFavoriteList();
    },
    postFavoriteSizeChange(val) {
      this.postFavoritePage.pageSize = val;
      this.getPostFavoriteList();
    },
  }
}
